import { Component, EventEmitter, Input, Output, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { FileUpload } from 'primeng/fileupload';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';
import { Subscription } from 'rxjs';
import { DmsFile } from '../../../modal/upload/model/upload.model';
import { UploadService } from '../../../services/upload/upload.service';


@Component({
  selector: 'app-pre-bid',
  standalone: false,
  templateUrl: './pre-bid.component.html',
  styleUrl: './pre-bid.component.scss'
})
export class PreBidComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() id: any
  @Input() getUrl: string;
  @Input() postUrl: string;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  @Output() stepCompleted = new EventEmitter<void>();
  commentForm: FormGroup;
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: string;
  

  payload: {
    proposal_id: any;
    // proposal_step:proposalStep,
    proposal_name: any;
  };
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  uploadedUrl: any;
  apiUrl = environment.APIUrl;
  uploadedFileName: string = '';
  file: File;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  private subscriptions = new Subscription();
  userID: any;
  allDmsFiles: any[] = [];
  constructor(private fb: FormBuilder, private config: PrimeNGConfig,
    private messageService: MessageService, private api: ApiService,
    private uploadService: UploadService, private route: ActivatedRoute) {
    this.commentForm = this.fb.group({
      pre_bid: ['', Validators.required],
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      // const proposalStep = params['step'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        // proposal_step:proposalStep,
        proposal_name: proposalName
      }
      //console.log(this.payload);
    });
    this.commentForm = this.fb.group({
      pre_bid: ['', Validators.required],
    });
    this.getRfpDetails();
    //     if (this.isEditable) {
    //   this.commentForm.enable();
    // } else {
    //   this.commentForm.disable();
    // }
    console.log("step is", this.step);
  }

  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
  expandedSections: { [key: string]: boolean } =
    {
      basicInfo: true,
      equipment: false,
      quantity: false,
      cost: false,
      detailedInfo: false,
      uploads: false,
      vendorTable: false
    };
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled
    };
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  //   getQueryApiUrl() {
  //   const base = this.apiUrl;

  //   if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
  //     return `/make1/pre-eol/query/?preeol__proposal_step=${this.step.id}&preeol__proposal_step__proposal=${this.payload.proposal_id}`;
  //   }

  //   // default (rev, tdf...)
  //   return `/revenue/pre-bid/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`;
  // }
  getQueryApiUrl() {
    const base = this.apiUrl;

    // Check if this is a P_QR step
    if (this.stepDetails?.code === 'P_QR') {
      return `/preparation/question/query/?pre_question__proposal_step=${this.step.id}&pre_question__proposal_step__proposal=${this.payload.proposal_id}`;
    }

    if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
      return `/make1/pre-eol/query/?preeol__proposal_step=${this.step.id}&preeol__proposal_step__proposal=${this.payload.proposal_id}`;
    }

    // default (rev, tdf...)
    return `/revenue/pre-bid/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    
    
  }

  rfpdata: any;
  preeolId: any; // Store the preeol ID for make schemes
  prequery: any;
  // getRfpDetails() {
  //   const sub = this.api.getAPI(`/revenue/pre-bid/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`).subscribe((res: any) => {
  //     this.rfpdata = res[0];
  //     console.log('this is pre-bid', this.rfpdata);
  //     const dmsFiles: DmsFile[] = this.rfpdata.dms_files;
  //     this.allDmsFiles = dmsFiles;
  //     this.uploadedUrl = res[0].mom || null;
  //     this.commentForm.patchValue({
  //       pre_bid: this.rfpdata?.paragraph
  //     });
  //     this.rows = res[0].prebid_query
  //   });
  //   this.subscriptions.add(sub);
  // }
  //   getRfpDetails() {
  //   // For make schemes, we need to fetch both the main preeol record and the queries separately
  //   if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
  //     // Fetch main preeol record for paragraph, dms_files, etc.
  //     const preeolUrl = `/make1/pre-eol/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`;
  //     const preeolSub = this.api.getAPI(preeolUrl).subscribe((res: any) => {
  //       if (res && res[0]) {
  //         this.rfpdata = res[0];
  //         this.preeolId = res[0].id;
  //         console.log("PREEOL DATA:", this.rfpdata);
  //         console.log("PREEOL ID:", this.preeolId);

  //         const dmsFiles: DmsFile[] = this.rfpdata?.dms_files || [];
  //         this.allDmsFiles = dmsFiles;
  //         this.uploadedUrl = this.rfpdata?.mom || null;

  //         this.commentForm.patchValue({
  //           pre_bid: this.rfpdata?.justification  || ''
  //         });
  //       }
  //     });
  //     this.subscriptions.add(preeolSub);

  //     // Fetch query records - this returns an array directly
  //     const queryUrl = `/make1/pre-eol/query/?preeol__proposal_step=${this.step.id}&preeol__proposal_step__proposal=${this.payload.proposal_id}`;
  //     const querySub = this.api.getAPI(queryUrl).subscribe((res: any) => {
  //       console.log("PREEOL QUERY DATA:", res);
  //       // For make schemes, the query API returns an array of query objects directly
  //       if (Array.isArray(res)) {
  //         this.rows = res.map((row: any) => ({
  //           ...row,
  //           edit: false
  //         }));
  //       } else if (res && Array.isArray(res.results)) {
  //         this.rows = res.results.map((row: any) => ({
  //           ...row,
  //           edit: false
  //         }));
  //       } else {
  //         this.rows = [];
  //       }
  //       console.log("ROWS:", this.rows);
  //     });
  //     this.subscriptions.add(querySub);
  //   } else {
  //     // For revenue schemes, use the existing logic
  //     const url = this.getQueryApiUrl();
  //     const sub = this.api.getAPI(url).subscribe((res: any) => {
  //       this.rfpdata = res[0];
  //       console.log("PRE-BID DATA:", this.rfpdata);

  //       const dmsFiles: DmsFile[] = this.rfpdata?.dms_files || [];
  //       this.allDmsFiles = dmsFiles;
  //       this.uploadedUrl = this.rfpdata?.mom || null;

  //       this.commentForm.patchValue({
  //         pre_bid: this.rfpdata?.justification || ''
  //       });

  //       // for revenue schemes
  //       this.rows = this.rfpdata?.prebid_query || [];
  //     });
  //     this.subscriptions.add(sub);
  //   }
  // }

  getRfpDetails() {
    
    // Handle P_QR step
    if (this.stepDetails?.code === 'P_QR') {
      console.log("Fetching data for P_QR step", this.stepDetails?.code);
      // Fetch main preparation/question record
      const mainUrl = `/make1/preparation/question/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`;
      const mainSub = this.api.getAPI(mainUrl).subscribe((res: any) => {
        if (res && res.id) {
          console.log("MAIN PREPARATION QUESTION DATA FETCHED:", res[0], res);
          this.prequery = res.id;
          // this.rfpdata = res[0];
          // this.preeolId = res[0].id; // Store the preparation question ID
          // this.prequery = res[0].id || [];



          console.log("PREPARATION QUESTION DATA:", this.rfpdata, this.prequery);

          const dmsFiles: DmsFile[] = this.rfpdata?.dms_files || [];
          this.allDmsFiles = dmsFiles;
          this.uploadedUrl = this.rfpdata?.mom || null;

          this.commentForm.patchValue({
            // pre_bid: this.prequery?.justification || ''
            pre_bid: res?.justification || '',
          });
        }
      });
      this.subscriptions.add(mainSub);

      // Fetch query records
      const queryUrl = `/make1/preparation/question/query/?pre_question__proposal_step=${this.step.id}&pre_question__proposal_step__proposal=${this.payload.proposal_id}`;
      const querySub = this.api.getAPI(queryUrl).subscribe((res: any) => {
        console.log("PREPARATION QUESTION QUERY DATA:", res);
        if (Array.isArray(res)) {
          this.rows = res.map((row: any) => ({
            ...row,
            edit: false
          }));
        } else if (res && Array.isArray(res.results)) {
          this.rows = res.results.map((row: any) => ({
            ...row,
            edit: false
          }));
        } else {
          this.rows = [];
        }
        console.log("ROWS:", this.rows);
      });
      this.subscriptions.add(querySub);
      return;
    }

    // For make schemes
    if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
      const preeolUrl = `/make1/pre-eol/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`;
      const preeolSub = this.api.getAPI(preeolUrl).subscribe((res: any) => {
        if (res && res[0]) {
          this.rfpdata = res[0];
          this.preeolId = res[0].id;
          this.prequery = res[0].id || [];
          console.log("PREEOL DATA:", this.rfpdata);

          const dmsFiles: DmsFile[] = this.rfpdata?.dms_files || [];
          this.allDmsFiles = dmsFiles;
          this.uploadedUrl = this.rfpdata?.mom || null;

          this.commentForm.patchValue({
            pre_bid: this.rfpdata?.justification || '',
          });
        }
      });
      this.subscriptions.add(preeolSub);

      const queryUrl = `/make1/pre-eol/query/?preeol__proposal_step=${this.step.id}&preeol__proposal_step__proposal=${this.payload.proposal_id}`;
      const querySub = this.api.getAPI(queryUrl).subscribe((res: any) => {
        console.log("PREEOL QUERY DATA:", res);
        if (Array.isArray(res)) {
          this.rows = res.map((row: any) => ({
            ...row,
            edit: false
          }));
        } else if (res && Array.isArray(res.results)) {
          this.rows = res.results.map((row: any) => ({
            ...row,
            edit: false
          }));
        } else {
          this.rows = [];
        }
        console.log("ROWS:", this.rows);
      });
      this.subscriptions.add(querySub);
    } else {
      // For revenue schemes
      const url = this.getQueryApiUrl();
      
      const sub = this.api.getAPI(url).subscribe((res: any) => {
        // API now returns { data: [...], vendor_data: ... } — extract from res.data
        const responseData = res?.data || res.vendor_data.revenuevendor_step[0];
        // const checkRes = res.vendor_data.revenuevendor_step[0];
        this.rfpdata = Array.isArray(responseData) ? responseData[0] : responseData;
        console.log("PRE-BID DATA:", this.rfpdata);

        // console.log("PRE-BID DATA:", this.rfpdata, checkRes);

        const dmsFiles: DmsFile[] = this.rfpdata?.dms_files || [];
        this.allDmsFiles = dmsFiles;
        this.uploadedUrl = this.rfpdata?.mom || null;

        this.commentForm.patchValue({
          pre_bid: this.rfpdata?.paragraph || ''
        });

        this.rows = (this.rfpdata?.prebid_query || []).map((row: any) => ({
          ...row,
          edit: false
        }));
        // Merge vendor_data.revenuevendor_step with saved prebid_attendees
        const attendees = this.rfpdata?.prebid_attendees || [];
        const vendorSteps = res?.vendor_data?.revenuevendor_step || [];

        // Build a map of saved attendees keyed by vendor name (trimmed, lowercased)
        const savedMap = new Map<string, any>();
        attendees.forEach((a: any) => {
          const key = (a.vendor || '').trim().toLowerCase();
          if (key) savedMap.set(key, a);
        });

        // Start with all vendors from revenuevendor_step
        this.revVendorSummary = vendorSteps.map((vs: any) => {
          const vendorName = vs.name || vs.company_name || '';
          const key = vendorName.trim().toLowerCase();
          const saved = savedMap.get(key);
          if (saved) {
            savedMap.delete(key); // mark as matched
            return {
              id: saved.id,
              vendor_name: saved.vendor || vendorName,
              rfp_received: !!saved.rfp_recieve,
              meeting_attended: !!saved.meeting_attend,
              editMode: false
            };
          }
          // Vendor not yet saved — show with defaults
          return {
            vendor_name: vendorName,
            rfp_received: false,
            meeting_attended: false,
            editMode: false
          };
        });

        // Append any saved attendees that didn't match a revenuevendor_step entry
        savedMap.forEach((a: any) => {
          this.revVendorSummary.push({
            id: a.id,
            vendor_name: a.vendor || '',
            rfp_received: !!a.rfp_recieve,
            meeting_attended: !!a.meeting_attend,
            editMode: false
          });
        });
      });
      this.subscriptions.add(sub);
    }
  }



  // onSubmit(): void {
  //   // if (this.commentForm.valid) {
  //   const formData = new FormData();
  //   formData.append('proposal_step', this.id);
  //   formData.append('paragraph', this.commentForm.get('pre_bid').value);
  //   if (this.file) {
  //     formData.append('mom', this.file);
  //   }

  //   if (this.rfpdata) {
  //     const sub = this.api.putAPI(`/revenue/pre-bid/${this.rfpdata.id}/`, formData).subscribe((res: any) => {
  //       this.getRfpDetails();
  //       this.fileUpload.clear()
  //       this.uploadedFileName = null;
  //       this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Pre-Bid Meeting updated successfully' });
  //     });
  //     this.subscriptions.add(sub);

  //   } else {
  //     const sub = this.api.postAPI('/revenue/pre-bid/', formData).subscribe((res: any) => {
  //       this.getRfpDetails();
  //       this.fileUpload.clear()
  //       this.uploadedFileName = null;
  //       this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Pre-Bid Meeting uploaded successfully' });
  //     });
  //     this.subscriptions.add(sub);
  //   }
  //   // } else {
  //   //   this.commentForm.markAllAsTouched();
  //   // }
  // }
  //   onSubmit(): void {
  //   const formData = new FormData();
  //   formData.append('proposal_step', this.id);
  //   formData.append('justification', this.commentForm.get('pre_bid').value);

  //   if (this.file) formData.append('mom', this.file);

  //   let postUrl = '/revenue/pre-bid/';
  //   let putUrl = `/revenue/pre-bid/${this.rfpdata?.id}/`;

  //   if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
  //     postUrl = 'make1/pre-eol/';
  //     putUrl = `make1/pre-eol/${this.rfpdata?.id}/`;
  //   }

  //   const apiCall = this.rfpdata
  //     ? this.api.putAPI(putUrl, formData)
  //     : this.api.postAPI(postUrl, formData);

  //   const sub = apiCall.subscribe((res: any) => {
  //     this.getRfpDetails();
  //     this.fileUpload.clear();
  //     this.uploadedFileName = null;

  //     this.messageService.add({
  //       severity: 'success',
  //       summary: 'Success',
  //       detail: res.message || 'Updated successfully'
  //     });
  //   });

  //   this.subscriptions.add(sub);
  // }

  onSubmit(): void {
    
    console.log("this.schemeType", this.schemeType ,this.rfpdata );
    
    console.log('onSubmit', this.commentForm.get('pre_bid').value);
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('justification', this.commentForm.get('pre_bid').value);

    if (this.file) formData.append('mom', this.file);

    // let postUrl = '/revenue/pre-bid/';
    // let putUrl = `/revenue/pre-bid/${this.rfpdata?.id}/`;
    if (this.schemeType == 'rev' && this.rfpdata) {
      formData.append('paragraph', this.commentForm.get('pre_bid').value);
      const sub = this.api.putAPI(`/revenue/pre-bid/${this.rfpdata.id}/`, formData).subscribe((res: any) => {
        this.getRfpDetails();
        this.uploadedFileName = null;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data updated successfully' });
      });
      this.subscriptions.add(sub);

    } else if (this.schemeType == 'rev' && !this.rfpdata) {
      formData.append('paragraph', this.commentForm.get('pre_bid').value);
      const sub = this.api.postAPI('/revenue/pre-bid/', formData).subscribe((res: any) => {
        this.getRfpDetails();
        this.uploadedFileName = null;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data uploaded successfully' });
      });
      this.subscriptions.add(sub);
    }

    if (this.stepDetails?.code === 'P_QR' && this.prequery) {
      const sub = this.api.putAPI(`/make1/preparation/question/${this.prequery}/`, formData).subscribe((res: any) => {
        this.getRfpDetails();
        this.uploadedFileName = null;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data updated successfully' });
      });
      this.subscriptions.add(sub);

    } else if (this.stepDetails?.code === 'P_QR' && !this.prequery) {
      const sub = this.api.postAPI('/make1/preparation/question/', formData).subscribe((res: any) => {
        this.getRfpDetails();
        this.uploadedFileName = null;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data uploaded successfully' });
      });
      this.subscriptions.add(sub);
    } else if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType) && this.preeolId) {

      const sub = this.api.putAPI(`/make1/pre-eol/${this.preeolId}/`, formData).subscribe((res: any) => {
        this.getRfpDetails();
        this.uploadedFileName = null;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data updated successfully' });
      });
      this.subscriptions.add(sub);

    } else if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType) && !this.preeolId) {
      const sub = this.api.postAPI('/make1/pre-eol/', formData).subscribe((res: any) => {
        this.getRfpDetails();
        this.uploadedFileName = null;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data uploaded successfully' });
      });
      this.subscriptions.add(sub);
    }

    // Handle P_QR step
    // if (this.stepDetails?.code === 'P_QR') {
    //   postUrl = '/make1/preparation/question/';
    //   putUrl = `/make1/preparation/question/${this.rfpdata?.id}/`;
    // } else if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
    //   postUrl = '/make1/pre-eol/';
    //   putUrl = `/make1/pre-eol/${this.rfpdata?.id}/`;
    // }

    // const apiCall = this.rfpdata
    //   ? this.api.putAPI(putUrl, formData)
    //   : this.api.postAPI(postUrl, formData);

    // const sub = apiCall.subscribe((res: any) => {
    //   this.getRfpDetails();
    //   this.fileUpload.clear();
    //   this.uploadedFileName = null;

    //   this.messageService.add({
    //     severity: 'success',
    //     summary: 'Success',
    //     detail: res.message || 'Updated successfully'
    //   });
    // });

    // this.subscriptions.add(sub);
  }


  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.payload.proposal_name },
        { key: "Pre-Bid Meeting", value: this.commentForm.get('pre_bid')?.value },
      ]
    }
    this.generatePDFEmitter.emit(payload);
  }


  editForm() {
    this.commentForm.enable();
    this.messageService.add({ severity: 'info', summary: 'info', detail: 'Form is now editable.' });
  }

  /** For schemeType rev: vendor attendees from prebid_attendees (id present after save). */
  revVendorSummary: { id?: number; vendor_name: string; rfp_received: boolean; meeting_attended: boolean; editMode?: boolean }[] = [];

  addRevVendorRow(): void {
    if (!this.revVendorSummary) this.revVendorSummary = [];
    this.revVendorSummary.push({ vendor_name: '', rfp_received: false, meeting_attended: false });
  }

  /** Save or update vendor attendee: POST for new row, PUT for existing. */
  saveVendorAttendee(v: { id?: number; vendor_name: string; rfp_received: boolean; meeting_attended: boolean; editMode?: boolean }): void {
    if (!this.rfpdata?.id) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Save pre-bid section first.' });
      return;
    }
    const payload = {
      vendor: (v.vendor_name || '').trim(),
      rfp_recieve: !!v.rfp_received,
      meeting_attend: !!v.meeting_attended
    };
    if (v.id != null) {
      const sub = this.api.putAPI(`/revenue/pre-bid/attendees/${v.id}/`, payload).subscribe(
        (res: any) => {
          this.getRfpDetails();
          this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Vendor attendee updated.' });
        },
        (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.detail || 'Failed to update.' });
        }
      );
      this.subscriptions.add(sub);
    } else {
      const postPayload = { prebid: this.rfpdata.id, ...payload };
      const sub = this.api.postAPI('/revenue/pre-bid/attendees/', postPayload).subscribe(
        (res: any) => {
          this.getRfpDetails();
          this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Vendor attendee added.' });
        },
        (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.detail || 'Failed to add.' });
        }
      );
      this.subscriptions.add(sub);
    }
  }

  rows = [
    // {id:'' ,sequence:'', query: '', reply: '' }
  ];

  // saveRow(row: any) {
  //   console.log("Saved Row:", row);
  //   let payload = {
  //     prebid: this.rfpdata?.id,
  //     query: row.query,
  //     reply: row.reply,
  //     vendor_name: row.vendor_name,
  //     sequence: row.sequence

  //   }
  //   if (row.id) {
  //     const sub = this.api.putAPI(`/revenue/pre-bid/query/${row.id}/`, payload).subscribe((res: any) => {
  //       this.getRfpDetails();
  //       this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Pre-Bid Meeting record updated successfully' });
  //     });
  //     this.subscriptions.add(sub);

  //   } else {
  //     const sub = this.api.postAPI('/revenue/pre-bid/query/', payload).subscribe((res: any) => {
  //       this.getRfpDetails();
  //       this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Pre-Bid Meeting record uploaded successfully' });
  //     });
  //     this.subscriptions.add(sub);
  //   }
  // }
  //   saveRow(row: any) {
  //   let basePost = '/revenue/pre-bid/query/';
  //   let basePut = '/revenue/pre-bid/query/';

  //   if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
  //     basePost = '/make1/pre-eol/query/';
  //     basePut = '/make1/pre-eol/query/';
  //   }

  //   // Use preeol for make schemes, prebid for others
  //   const payload: any = {
  //     query: row.query,
  //     reply: row.reply,
  //     vendor_name: row.vendor_name,
  //     sequence: row.sequence
  //   };

  //   if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
  //     payload.preeol = this.preeolId;
  //   } else {
  //     payload.prebid = this.rfpdata?.id;
  //   }

  //   const apiCall = row.id
  //     ? this.api.putAPI(`${basePut}${row.id}/`, payload)
  //     : this.api.postAPI(basePost, payload);

  //   const sub = apiCall.subscribe((res: any) => {
  //     this.getRfpDetails();
  //     this.messageService.add({
  //       severity: 'success',
  //       summary: 'Success',
  //       detail: res.message || 'Record saved successfully'
  //     });
  //   }, (err) => {
  //     console.error('Error saving row:', err);
  //     this.messageService.add({
  //       severity: 'error',
  //       summary: 'Error',
  //       detail: err?.error?.detail || err?.error?.preeol?.[0] || 'Failed to save record'
  //     });
  //   });

  //   this.subscriptions.add(sub);
  // }
  saveRow(row: any) {
    console.log("row",row);
    
    let basePost = '/revenue/pre-bid/query/';
    let basePut = '/revenue/pre-bid/query/';

    // API selection
    if (this.stepDetails?.code === 'P_QR') {
      basePost = '/make1/preparation/question/query/';
      basePut = '/make1/preparation/question/query/';
    }
    else if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
      basePost = '/make1/pre-eol/query/';
      basePut = '/make1/pre-eol/query/';
    }

    const payload: any = {
      applicant_name: row.vendor_name,
      query: row.query,
      reply: row.reply,
      vendor_name: row.vendor_name,
      // applicant_name : row.applicant_name,
      sequence: row.sequence,
      responded_by: row.responded_by ?? null,
      action_taken_by: row.action_taken_by ?? null,
      // pre_question: row.pre_question,

    };

    // Foreign key assignment
    if (this.stepDetails?.code === 'P_QR') {
      console.log("prequery id is", this.prequery);
      payload.pre_question = this.prequery;
    }
    else if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
      payload.preeol = this.preeolId;
    }else if (this.schemeType === 'rev') {
  payload.prebid = this.rfpdata?.id;  // ✅ always 65
}
    else {
      payload.prebid = this.rfpdata?.id;
    }

    const apiCall = row.id
      ? this.api.putAPI(`${basePut}${row.id}/`, payload)
      : this.api.postAPI(basePost, payload);

    const sub = apiCall.subscribe(
      (res: any) => {
        this.getRfpDetails();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Record saved successfully'
        });
      },
      (err) => {
        console.error('Error saving row:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail:
            err?.error?.detail ||
            err?.error?.pre_question?.[0] ||
            err?.error?.preeol?.[0] ||
            err?.error?.prebid?.[0] ||
            'Failed to save record'
        });
      }
    );

    this.subscriptions.add(sub);
  }



  addRow() {
    if (!this.rows) {
      this.rows = [];
    }
    this.rows.push({ sequence: '', query: '', reply: '', vendor_name: '', edit: true });
  }
}



